import { Command } from './types';

/**
 * System commands that interact with core application functionality
 */

interface LogoutCommandOptions {
	onCommandPaletteClose?: () => void;
	onShowLogoutDialog?: () => void;
}

/**
 * Creates a logout command that requires confirmation before execution
 */
export function createLogoutCommand(options: LogoutCommandOptions = {}): Command {
	return {
		id: 'system.logout',
		title: 'Logout',
		description: 'Sign out of your account',
		action: async () => {
			// Close command palette first if handler provided
			options.onCommandPaletteClose?.();

			// Show confirmation dialog
			options.onShowLogoutDialog?.();
		},
	};
}

interface SettingsCommandOptions {
	onCommandPaletteClose?: () => void;
	onShowComingSoonDialog?: () => void;
}

/**
 * Creates a settings command that shows a "Coming soon" message
 */
export function createSettingsCommand(options: SettingsCommandOptions = {}): Command {
	return {
		id: 'system.settings',
		title: 'Settings',
		description: 'Configure application preferences',
		action: async () => {
			// Close command palette first if handler provided
			options.onCommandPaletteClose?.();

			// Show coming soon dialog
			options.onShowComingSoonDialog?.();
		},
	};
}
